module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-month-12-66417acda6dc6760f20f21cdb46406d7.svg";